"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/fi-FI.ts
var fi_FI_exports = {};
__export(fi_FI_exports, {
  AG_CHARTS_LOCALE_FI_FI: () => AG_CHARTS_LOCALE_FI_FI
});
module.exports = __toCommonJS(fi_FI_exports);
var AG_CHARTS_LOCALE_FI_FI = {
  ariaAnnounceChart: "kaavio, ${seriesCount}[number] sarjaa",
  ariaAnnounceFlowProportionLink: "linkki ${index} / ${count}, l\xE4htien ${from} p\xE4\xE4ttyen ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "solmu ${index} ${count} n\xE4kyviss\xE4, ${description}",
  ariaAnnounceGaugeChart: "mittarikaavio, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkkinen kaavio, ${caption}",
  ariaAnnounceHierarchyDatum: "taso ${level}[number], ${count}[number] lasta, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Paina v\xE4lily\xF6nti\xE4 tai Enteri\xE4 vaihtaaksesi n\xE4kyvyytt\xE4",
  ariaLabelAddHorizontalLine: "Lis\xE4\xE4 vaakasuora viiva",
  ariaLabelAnnotationOptionsToolbar: "Merkinn\xE4n vaihtoehdot",
  ariaLabelAnnotationSettingsDialog: "Merkinn\xE4n asetukset",
  ariaLabelColorPicker: "V\xE4rinvalitsin",
  ariaLabelFinancialCharts: "Taloudelliset kaaviot",
  ariaLabelLegend: "Selite",
  ariaLabelLegendItem: "${label}, Legendan kohde ${index}[number] ${count}[number] kohteesta",
  ariaLabelLegendItemUnknown: "Tuntematon legenda-esiintym\xE4",
  ariaLabelLegendPageNext: "Seuraava selitteen sivu",
  ariaLabelLegendPagePrevious: "Edellinen selitesivu",
  ariaLabelLegendPagination: "Legendan sivutus",
  ariaLabelNavigator: "Navigaattori",
  ariaLabelNavigatorMaximum: "Maksimi",
  ariaLabelNavigatorMinimum: "Minimi",
  ariaLabelNavigatorRange: "Alue",
  ariaLabelRangesToolbar: "Alueet",
  ariaLabelSettingsTabBar: "Asetukset",
  ariaLabelZoomToolbar: "Zoomaa",
  ariaValuePanRange: "${min}[percent0to2dp] - ${max}[percent0to2dp]",
  contextMenuDownload: "Lataa",
  contextMenuPanToCursor: "Siirry t\xE4h\xE4n",
  contextMenuToggleOtherSeries: "Vaihda muiden sarjojen n\xE4kyvyytt\xE4",
  contextMenuToggleSeriesVisibility: "Vaihda n\xE4kyvyytt\xE4",
  contextMenuZoomToCursor: "Zoomaa t\xE4h\xE4n",
  dialogHeaderChannel: "Kanava",
  dialogHeaderDatePriceRange: "P\xE4iv\xE4m\xE4\xE4r\xE4 ja hinta",
  dialogHeaderDateRange: "Aikav\xE4li",
  dialogHeaderFibonacciRange: "Fib-palautus",
  dialogHeaderLine: "Viiva",
  dialogHeaderPriceRange: "Hintaluokka",
  dialogHeaderText: "Teksti",
  dialogInputAlign: "Tasaa",
  dialogInputColorPicker: "V\xE4ri",
  dialogInputColorPickerAltText: "Tekstin v\xE4ri",
  dialogInputExtendAbove: "Laajenna yl\xE4puolelle",
  dialogInputExtendBelow: "Laajenna alle",
  dialogInputExtendChannelEnd: "Jatka kanavan p\xE4\xE4t\xE4",
  dialogInputExtendChannelStart: "Laajenna kanavan alkua",
  dialogInputExtendLeft: "Laajenna vasemmalle",
  dialogInputExtendLineEnd: "Jatka viivan loppua",
  dialogInputExtendLineStart: "Laajenna viivan alkua",
  dialogInputExtendRight: "Laajenna oikealle",
  dialogInputFibonacciBands: "Kaistat",
  dialogInputFibonacciBandsAltText: "Fibonacci-kaistat",
  dialogInputFillColorPicker: "T\xE4yt\xE4",
  dialogInputFillColorPickerAltText: "T\xE4ytt\xF6v\xE4ri",
  dialogInputFontSize: "Koko",
  dialogInputFontSizeAltText: "Kirjasinkoko",
  dialogInputLineStyle: "Viiva",
  dialogInputPosition: "Sijainti",
  dialogInputReverse: "K\xE4\xE4nteinen",
  dialogInputShowFill: "N\xE4yt\xE4 t\xE4ytt\xF6",
  dialogInputStrokeWidth: "Viivan paksuus",
  dialogInputStrokeWidthAltText: "Viivan leveys",
  iconAltTextAlignCenter: "Keskit\xE4",
  iconAltTextAlignLeft: "Vasen",
  iconAltTextAlignRight: "Oikea",
  iconAltTextClose: "Sulje",
  iconAltTextLineStyleDashed: "Pitk\xE4viivainen",
  iconAltTextLineStyleDotted: "Lyhytkatkoviivainen",
  iconAltTextLineStyleSolid: "Yhten\xE4inen",
  iconAltTextPositionBottom: "Alhaalla",
  iconAltTextPositionCenter: "Keskusta",
  iconAltTextPositionTop: "Yl\xE4osa",
  inputTextareaPlaceholder: "Lis\xE4\xE4 teksti\xE4",
  measurerDateRangeBars: "${value}[number] palkit",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "\u2018${value}[number]\u2019",
  measurerVolume: "Tilavuus ${value}",
  overlayLoadingData: "Ladataan tietoja...",
  overlayNoData: "Ei n\xE4ytett\xE4v\xE4\xE4 dataa",
  overlayNoVisibleSeries: "Ei n\xE4kyviss\xE4 olevia sarjoja",
  overlayUnsupportedBrowser: "Yhteensopimaton selaimen versio. P\xE4ivit\xE4 selaimesi.",
  seriesHistogramTooltipCount: "${yName} (m\xE4\xE4r\xE4)",
  seriesHistogramTooltipFrequency: "Tiheys",
  seriesHistogramTooltipMean: "${yName} (keskiarvo)",
  seriesHistogramTooltipSum: "${yName} (summa)",
  toolbarAnnotationsArrow: "Nuoli",
  toolbarAnnotationsArrowDown: "Nuoli alas",
  toolbarAnnotationsArrowUp: "Nuoli yl\xF6s",
  toolbarAnnotationsCallout: "Huomautus",
  toolbarAnnotationsClearAll: "Tyhjenn\xE4 kaikki",
  toolbarAnnotationsComment: "Kommentoi",
  toolbarAnnotationsDatePriceRange: "P\xE4iv\xE4ys ja Hinta",
  toolbarAnnotationsDateRange: "Aikav\xE4li",
  toolbarAnnotationsDelete: "Poista",
  toolbarAnnotationsDisjointChannel: "Ep\xE4yhten\xE4inen kanava",
  toolbarAnnotationsDragHandle: "Ved\xE4 ty\xF6kalurivi\xE4",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trendiin Perustuva",
  toolbarAnnotationsFillColor: "T\xE4ytt\xF6v\xE4ri",
  toolbarAnnotationsHorizontalLine: "Vaakasuora viiva",
  toolbarAnnotationsLineAnnotations: "Trendiviivat",
  toolbarAnnotationsLineColor: "V\xE4ri",
  toolbarAnnotationsLineStrokeWidth: "Viivan paksuus",
  toolbarAnnotationsLineStyle: "Viivatyylit",
  toolbarAnnotationsLock: "Lukitse",
  toolbarAnnotationsMeasurerAnnotations: "Mittaukset",
  toolbarAnnotationsNote: "Muistio",
  toolbarAnnotationsParallelChannel: "Rinnakkaiskanava",
  toolbarAnnotationsPriceRange: "Hintahaarukka",
  toolbarAnnotationsQuickDatePriceRange: "Mittaa",
  toolbarAnnotationsSettings: "Asetukset",
  toolbarAnnotationsShapeAnnotations: "Nuolia",
  toolbarAnnotationsText: "Teksti",
  toolbarAnnotationsTextAnnotations: "Tekstihuomautukset",
  toolbarAnnotationsTextColor: "Tekstin v\xE4ri",
  toolbarAnnotationsTextSize: "Tekstin koko",
  toolbarAnnotationsTrendLine: "Trendi Viiva",
  toolbarAnnotationsUnlock: "Avaa lukitus",
  toolbarAnnotationsVerticalLine: "Pystysuora viiva",
  toolbarRange1Month: "1KK",
  toolbarRange1MonthAria: "1 kuukausi",
  toolbarRange1Year: "1V",
  toolbarRange1YearAria: "1 vuosi",
  toolbarRange3Months: "3kk",
  toolbarRange3MonthsAria: "3 kuukautta",
  toolbarRange6Months: "6 kk",
  toolbarRange6MonthsAria: "6 kuukautta",
  toolbarRangeAll: "Kaikki",
  toolbarRangeAllAria: "Kaikki",
  toolbarRangeYearToDate: "Vuodesta t\xE4h\xE4n p\xE4iv\xE4\xE4n",
  toolbarRangeYearToDateAria: "Vuosi t\xE4h\xE4n p\xE4iv\xE4\xE4n",
  toolbarSeriesTypeCandles: "Kynttil\xE4t",
  toolbarSeriesTypeDropdown: "Kaaviotyyppi",
  toolbarSeriesTypeHighLow: "Korkea Matala",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Ontot Kynttil\xE4t",
  toolbarSeriesTypeLine: "Viiva",
  toolbarSeriesTypeLineWithMarkers: "Viiva merkinn\xF6ill\xE4",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Askelviiva",
  toolbarZoomPanEnd: "Siirry loppuun",
  toolbarZoomPanLeft: "Vierit\xE4 vasemmalle",
  toolbarZoomPanRight: "Panoroi oikealle",
  toolbarZoomPanStart: "Panoroi alkuun",
  toolbarZoomReset: "Palauta zoomaus",
  toolbarZoomZoomIn: "L\xE4henn\xE4",
  toolbarZoomZoomOut: "Loitonna",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
//# sourceMappingURL=fi-FI.cjs.js.map
